module.exports = __webpack_public_path__ + "img/symbol_9.258311a8.png";